import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AiAgentConfigsAPI from '../../api/aiAgentConfigs';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getByAgentBotId: $state => agentBotId => {
    const [config] = $state.records.filter(
      record => record.agent_bot_id === Number(agentBotId)
    );
    return config;
  },
};

export const actions = {
  show: async ({ commit }, agentBotId) => {
    commit(types.SET_AI_AGENT_CONFIG_UI_FLAG, { isFetching: true });
    try {
      const response = await AiAgentConfigsAPI.show(agentBotId);
      commit(types.ADD_AI_AGENT_CONFIG, response.data);
      return response.data;
    } catch (error) {
      // A 404 simply means this bot has no AI agent config yet.
      if (error?.response?.status !== 404) {
        throwErrorMessage(error);
      }
      return null;
    } finally {
      commit(types.SET_AI_AGENT_CONFIG_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, { agentBotId, data }) => {
    commit(types.SET_AI_AGENT_CONFIG_UI_FLAG, { isCreating: true });
    try {
      const response = await AiAgentConfigsAPI.create(agentBotId, data);
      commit(types.ADD_AI_AGENT_CONFIG, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_AI_AGENT_CONFIG_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { agentBotId, data }) => {
    commit(types.SET_AI_AGENT_CONFIG_UI_FLAG, { isUpdating: true });
    try {
      const response = await AiAgentConfigsAPI.update(agentBotId, data);
      commit(types.ADD_AI_AGENT_CONFIG, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_AI_AGENT_CONFIG_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_AI_AGENT_CONFIG_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.ADD_AI_AGENT_CONFIG]: MutationHelpers.setSingleRecord,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
